module.exports = __webpack_public_path__ + "img/request-offer@2x.333d0ff.png";